import {useAtom} from 'jotai'

import {
  userDetailAtom,
  comissionDetailAtom,
  commissionListAtom,
  commissionListFilterAtom,
  isoListAtom,
  listAtom,
  listFilterAtom,
  recentTransactionsAtom,
  storeContactTitleListAtom,
  storeDetailAtom,
  tabAtom,
  tabFilterAtom,
  merchantDetailAtom,
} from '../store'

type Tab =
  | 'Contact'
  | 'Subscription'
  | 'Invoice'
  | 'Transaction'
  | 'TPN'
  | 'Optional'
  | 'User'
  | 'Activities'
  | 'UserDetail'
  | 'Commission'
  | 'CommissionDetail'
  | 'Engagement'
  | 'SmsEngagement'
  | 'PushEngagement'
  | 'EmailEngagement'

export const useStore = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)

  const [tab, tabSet] = useAtom(tabAtom)
  const [detail, detailSet] = useAtom(storeDetailAtom)
  const [recentTransactions, recentTransactionsSet] = useAtom(recentTransactionsAtom)

  const [storeContactTitleList, storeContactTitleListSet] = useAtom(storeContactTitleListAtom)

  const [userDetail, userDetailSet] = useAtom(userDetailAtom)

  const [comissionDetail, comissionDetailSet] = useAtom(comissionDetailAtom)
  const [commissionList, commissionListSet] = useAtom(commissionListAtom)
  const [commissionListFilter, commissionListFilterSet] = useAtom(commissionListFilterAtom)

  const [isoList, isoListSet] = useAtom(isoListAtom)

  const [tabFilter, tabFilterSet] = useAtom(tabFilterAtom)

  const updateDetail = (data: any, type: Tab) => {
    let newData = {...data}

    detailSet((prev: any) => {
      //if (!prev) return null

      return {
        ...prev,
        [type]: newData,
      }
    })
  }

  return {
    list,
    listSet,
    detail,
    detailSet,
    tab,
    tabSet,
    listFilter,
    listFilterSet,
    recentTransactions,
    recentTransactionsSet,
    storeContactTitleList,
    storeContactTitleListSet,
    userDetail,
    userDetailSet,
    comissionDetail,
    comissionDetailSet,
    commissionList,
    commissionListSet,
    commissionListFilter,
    commissionListFilterSet,
    isoList,
    isoListSet,
    updateDetail,
    tabFilter,
    tabFilterSet,
  }
}

export const useMerchant = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)

  const [tab, tabSet] = useAtom(tabAtom)
  const [detail, detailSet] = useAtom(merchantDetailAtom)
  const [recentTransactions, recentTransactionsSet] = useAtom(recentTransactionsAtom)

  const [storeContactTitleList, storeContactTitleListSet] = useAtom(storeContactTitleListAtom)

  const [userDetail, userDetailSet] = useAtom(userDetailAtom)

  const [comissionDetail, comissionDetailSet] = useAtom(comissionDetailAtom)
  const [commissionList, commissionListSet] = useAtom(commissionListAtom)
  const [commissionListFilter, commissionListFilterSet] = useAtom(commissionListFilterAtom)

  const [isoList, isoListSet] = useAtom(isoListAtom)

  const [tabFilter, tabFilterSet] = useAtom(tabFilterAtom)

  const updateDetail = (data: any, type: Tab) => {
    let newData = {...data}

    detailSet((prev) => {
      if (!prev) return null

      return {
        ...prev,
        [type]: newData,
      }
    })
  }

  return {
    list,
    listSet,
    detail,
    detailSet,
    tab,
    tabSet,
    listFilter,
    listFilterSet,
    recentTransactions,
    recentTransactionsSet,
    storeContactTitleList,
    storeContactTitleListSet,
    userDetail,
    userDetailSet,
    comissionDetail,
    comissionDetailSet,
    commissionList,
    commissionListSet,
    commissionListFilter,
    commissionListFilterSet,
    isoList,
    isoListSet,
    updateDetail,
    tabFilter,
    tabFilterSet,
  }
}
